module.exports = __webpack_public_path__ + "static/media/a-textbook-of-cultural-economics.6985dbef.jpg";